import { render, staticRenderFns } from "./PrivilegedBar.vue?vue&type=template&id=ba5cf9b6&"
import script from "./PrivilegedBar.vue?vue&type=script&lang=js&"
export * from "./PrivilegedBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports